import type { MedicationRequest } from '@/services/med-req-detail'

export const DEFAULT_VENDOR_HASH = '9dabf1cc4105e0b5575366a2b81d6664'

const MPS_MED_ORDER_TYPE = 'mps_med_order'
const MENOPAUSE_SERVICE_DISPLAY_NAME = 'Menopause Service'

export const getFanPrescribedItemDisplayName = (medRequest: MedicationRequest): string =>
  (medRequest.evaroType ?? '').toLowerCase() === MPS_MED_ORDER_TYPE
    ? MENOPAUSE_SERVICE_DISPLAY_NAME
    : medRequest.orderedItem.name

export const buildTemplateData = (
  medRequest: MedicationRequest,
  requiredFields: string[],
  editorContent?: string
): Record<string, unknown> => {
  const fieldMap: Record<string, unknown> = {
    orderId: medRequest.orderNumber,
    firstName: medRequest.patient?.firstName,
    prescriberName: medRequest.approvedBy ?? medRequest.prescriber?.fullName,
    prescribedItem: getFanPrescribedItemDisplayName(medRequest),
    content: editorContent || ''
  }

  return Object.fromEntries(requiredFields.map(field => [field, fieldMap[field] ?? '']))
}

export type FanTemplateId = 'cs-on-hold' | 'cs-refund' | 'cs-follow-up'

export interface FanTemplate {
  id: FanTemplateId
  name: string
  subject: string | null
  requiredFields: string[]
}

export const FAN_TEMPLATES: FanTemplate[] = [
  {
    id: 'cs-on-hold',
    name: 'On Hold (with custom content)',
    subject: 'Your order is on hold',
    requiredFields: ['orderId', 'firstName', 'prescriberName', 'prescribedItem', 'content']
  },
  {
    id: 'cs-refund',
    name: 'Refund (with custom content)',
    subject: 'Your order has been refunded',
    requiredFields: ['orderId', 'firstName', 'prescriberName', 'prescribedItem', 'content']
  },
  {
    id: 'cs-follow-up',
    name: 'Follow-up (with custom content)',
    subject: 'Following up on your recent order',
    requiredFields: ['orderId', 'firstName', 'prescriberName', 'prescribedItem', 'content']
  }
]
